import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, catchError, map, of, take } from 'rxjs';
import { RouteAccessRuleSet } from '../rules/rules';
import { UserRole } from '@shared/utils/base-auth';
import { inject } from '@angular/core';
import { OfficerDetailFacade } from '@intrensic/shared/officer-details';

export const RoleGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  const officerDetailFacade = inject(OfficerDetailFacade);
  const router = inject(Router);

  return officerDetailFacade.getLoggedInOfficer().pipe(
    take(1),
    map((officer) => {
      if (officer.role === UserRole.SuperAdmin || state.url === '/') {
        return true;
      }

      const routeAccess = RouteAccessRuleSet.find((rule) => rule.route === state.url || state.url.startsWith(rule.route));

      if (!routeAccess || !routeAccess.userRoles.includes(officer.role)) {
        router.navigate(['Error', '403']);

        return false;
      }

      return true;
    }),
    catchError(() => {
      router.navigate(['Error', 'InternalServer']);

      return of(false);
    })
  );
};
